module.exports = __webpack_public_path__ + "img/instagram-food-button-2.881a4a3f.png";